function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17109"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58137",
    d: "M12.047 0A12.047 12.047 0 0 0 0 11.953 12.127 12.127 0 0 0 12.047 24a12 12 0 0 0 0-24zm5.917 15.881a1.407 1.407 0 0 1-1.989 1.989l-3.927-3.929-4.023 3.93a1.407 1.407 0 0 1-1.989-1.989l3.928-3.928-3.928-3.929a1.407 1.407 0 1 1 1.989-1.989l4.021 3.929 3.927-3.929a1.407 1.407 0 0 1 1.989 1.989l-3.928 3.928z",
    style: {
      fill: "#d33f0d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelInactiveIcon);
export default __webpack_public_path__ + "static/media/cancelInactiveIcon.0d48a3259c7c723287665f70b60a4ff3.svg";
export { ForwardRef as ReactComponent };